import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { getSinglePhoneData } from '../../utils/getSinglePhoneData';
import { PhonePopupModal } from '../PhonePopupModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var PhonePopup = function PhonePopup(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    placeType = _ref.placeType,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    onOpen = _ref.onOpen,
    _ref$showPhoneStyles = _ref.showPhoneStyles,
    showPhoneStyles = _ref$showPhoneStyles === void 0 ? {} : _ref$showPhoneStyles;
  var _getSinglePhoneData = getSinglePhoneData({
      builders: builders,
      sellers: sellers
    }),
    buttonText = _getSinglePhoneData.buttonText;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setModalOpen = _React$useState2[1];
  var onClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!open) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            setModalOpen(true);

            /* istanbul ignore else */
            if (onOpen) {
              onOpen();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleClose = React.useCallback(function () {
    return setModalOpen(false);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PhonePopupModal, {
      open: open,
      builders: builders,
      sellers: sellers,
      httpApi: httpApi,
      logger: logger,
      placeType: placeType,
      pageType: pageType,
      platformType: platformType,
      onClose: handleClose
    }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, showPhoneStyles), {}, {
      onClick: onClick,
      "data-testid": "phone-button",
      children: buttonText
    }))]
  });
};